import { useStore } from 'effector-react'

import {
  $totalCountOfCompetitions,
  getCompetitions,
  competitionsListMounted,
  $competitions,
} from './model'
import { CompetitionRequest } from './types'

export const useCompetitionList = () => {
  const competitions = useStore($competitions)
  const loading = useStore(getCompetitions.pending)
  const totalCountOfCompetitions = useStore($totalCountOfCompetitions)

  const onChangeCompetitionsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
  }: CompetitionRequest) => {
    competitionsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
    })
  }

  return {
    competitions,
    totalCountOfCompetitions,
    loading,
    onChangeCompetitionsList,
  }
}
